import React, { useState, useEffect } from "react";
import "./App.css";
import NavBar from "./components/navbar/navbar";
import shortfetch from "./components/data/fetch";
import { Route, Switch, withRouter } from "react-router-dom";
import LoadingBar from "./components/data/loading";
import FormModellen from "./Unimog2.0/form/modellen";
import FormModellenDINH from "./Unimog2.0/form/modellen_DINH";
import DataModellen from "./Unimog2.0/overview/Information_Modellen";
import FormVideos from "./Unimog2.0/form/videos";
import FormPins from "./Unimog2.0/form/pins";
import Search from "./Unimog2.0/search";
import Home from "./Unimog2.0/home";
import TreinenOverzicht from "./Unimog2.0/treinen/Treinen_Overzicht";
import DataTreinen from "./Unimog2.0/treinen/Trein_Informatie";
import StatisticalOverview from "./Unimog2.0/statistical overview";
import OverviewVideos from "./Unimog2.0/overview/videos";
import CheckDuplicates from "./Unimog2.0/duplicates";

function App() {
  const [isAdmin, setIsAdmin] = useState(false);
  const [isGuest, setIsGuest] = useState(false);
  const [notVerified, setNotVerified] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  async function checkLogin() {
    let post_json = {
      type: "check_login",
      auth: localStorage.getItem("auth"),
    };

    let data = await shortfetch(post_json);

    setIsAdmin(data.isAdmin);
    setIsGuest(data.isGuest);

    if (data.isAdmin === false && data.isGuest === false) {
      setNotVerified(true);
    }

    setIsLoading(false);
  }

  useEffect(() => {
    checkLogin();
  }, []);

  if (isLoading) {
    return <LoadingBar />;
  }

  const NaviBar = withRouter(NavBar);
  const SearchRouter = withRouter(Search);
  return (
    <div className="App">
      <NaviBar isAdmin={isAdmin} isGuest={isGuest} notVerified={notVerified} />
      <Switch>
        <Route
          exacts
          from="/Treinen"
          render={(props) => <TreinenOverzicht {...props} />}
        />
        <Route
          exacts
          from="/Trein/:id"
          render={(props) => <DataTreinen {...props} />}
        />
        <Route
          exacts
          from="/Duplicates"
          render={(props) => <CheckDuplicates {...props} />}
        />
        <Route
          exacts
          from="/Statistical Overview"
          render={(props) => <StatisticalOverview {...props} />}
        />
        <Route
          exacts
          from="/Search/:page"
          render={(props) => <SearchRouter {...props} />}
        />
        <Route
          exacts
          from="/Form/Modellen/Die/Ik/Niet/Heb/:id"
          render={(props) => <FormModellenDINH {...props} />}
        />
        <Route
          exacts
          from="/Form/Modellen/:id"
          render={(props) => <FormModellen {...props} />}
        />
        <Route
          exact
          from="/Form/Video's/:id"
          render={(props) => <FormVideos {...props} />}
        />
        <Route
          exact
          from="/Form/Pins"
          render={(props) => <FormPins {...props} />}
        />
        <Route
          exacts
          from="/Data/Modellen/:id"
          render={(props) => <DataModellen {...props} />}
        />
        <Route
          exacts
          from="/Overview/Video/:id"
          render={(props) => <OverviewVideos {...props} />}
        />
        <Route
          render={(props) => <Home {...props} notVerified={notVerified} />}
        />
      </Switch>
    </div>
  );
}

export default App;
